import { useCallback } from "react";

import type { CatalogGroupDTO, Endpoint } from "sandbox/types";

import { useSandboxEndpoints } from "sandbox/api/hooks/useSandboxQueries";

let cachedEndpoints: Endpoint[] | null = null;

export const setEndpointCache = (groups: CatalogGroupDTO[]): void => {
  cachedEndpoints = groups.flatMap(g => g.endpoints as Endpoint[]);
};

export const findEndpoint = (id: string): Endpoint | undefined => {
  if (cachedEndpoints) return cachedEndpoints.find(e => e.id === id);
  return;
};

export const useFindEndpoint = () => {
  const { data } = useSandboxEndpoints();
  return useCallback(
    (id: string): Endpoint | undefined => {
      if (!data) return;
      for (const group of data) {
        const found = group.endpoints.find(e => e.id === id);
        if (found) return found as unknown as Endpoint;
      }
      return;
    },
    [data],
  );
};
